// extracted by mini-css-extract-plugin
module.exports = {"skipLink":"SkipLink_skip-link__K2Mpi"};